// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DzTM","content":"styles_content__tHeH8"};